module.exports = __webpack_public_path__ + "images/marker-sport.76ccfa.png";